<template>
  <section
    id="violations"
    class="section violations-section"
  >
    <div class="container">
      <div class="section-header">
        <span class="badge">Student Guidelines</span>
        <h2>Violations</h2>
        <p class="subtitle">
          Be aware of school policies to maintain a positive learning environment.
        </p>
      </div>

      <div class="violations-grid">
        <div
          v-for="violation in violations"
          :key="violation.id"
          :class="violation.severity"
          class="violation-card"
        >
          <div class="violation-icon">
            <i :class="violation.icon" />
          </div>
          <div class="violation-content">
            <h4>{{ violation.title }}</h4>
            <p>{{ violation.description }}</p>
            <span class="penalty">{{ violation.penalty }}</span>
          </div>
        </div>
      </div>

      <div class="violations-footer">
        <p>
          <i class="fas fa-info-circle" />
          For complete guidelines, please refer to the Student Handbook.
        </p>
        <router-link
          v-if="showReportButton"
          to="/sign-in"
          class="report-link"
        >
          Report Violation
          <i class="fas fa-arrow-right" />
        </router-link>
        <router-link
          to="/policies"
          class="handbook-link"
        >
          View Full Policies
          <i class="fas fa-arrow-right" />
        </router-link>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ViolationsSection',
  props: {
    showReportButton: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      violations: [
        {
          id: 1,
          title: 'No School ID',
          description: 'Students must wear their school ID at all times within campus premises.',
          icon: 'fas fa-id-card-alt',
          severity: 'minor',
          penalty: 'Warning / Community Service'
        },
        {
          id: 2,
          title: 'Improper Uniform',
          description: 'Complete and proper school uniform must be worn during class days.',
          icon: 'fas fa-tshirt',
          severity: 'minor',
          penalty: 'Warning / Community Service'
        },
        {
          id: 3,
          title: 'Inappropriate Haircut',
          description: 'Hair must be neat, clean, and follow school grooming standards.',
          icon: 'fas fa-cut',
          severity: 'minor',
          penalty: 'Warning / Grooming Day'
        },
        {
          id: 4,
          title: 'Double Tap (ID Sharing)',
          description: 'Lending or using another student\'s ID for attendance is strictly prohibited.',
          icon: 'fas fa-user-times',
          severity: 'major',
          penalty: 'Suspension / Disciplinary Action'
        },
        {
          id: 5,
          title: 'Unauthorized Absence',
          description: 'Leaving campus without proper clearance during school hours.',
          icon: 'fas fa-door-open',
          severity: 'major',
          penalty: 'Parent Conference / Suspension'
        },
        {
          id: 6,
          title: 'Disruptive Behavior',
          description: 'Actions that disturb classes or school activities are not tolerated.',
          icon: 'fas fa-exclamation-triangle',
          severity: 'major',
          penalty: 'Counseling / Suspension'
        }
      ]
    }
  }
}
</script>

<style scoped>
@import '../../../assets/css/landing/pages/services.css';

.violations-section {
  padding: 4rem 0;
  background: linear-gradient(180deg, #f8fafc 0%, #ffffff 100%);
}

.violations-section .container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1.5rem;
}

.violations-section .section-header {
  text-align: center;
  margin-bottom: 3rem;
}

.violations-section .badge {
  display: inline-block;
  padding: 0.5rem 1rem;
  background: linear-gradient(135deg, rgba(239, 68, 68, 0.1), rgba(220, 38, 38, 0.1));
  color: #dc2626;
  font-size: 0.8rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  border-radius: 50px;
  margin-bottom: 1rem;
}

.violations-section h2 {
  font-size: clamp(1.5rem, 4vw, 2.5rem);
  font-weight: 800;
  color: #1e293b;
  margin-bottom: 0.75rem;
}

.violations-section .subtitle {
  font-size: 1.125rem;
  color: #64748b;
  max-width: 600px;
  margin: 0 auto;
}

.violations-footer {
  margin-top: 2.5rem;
  text-align: center;
  padding-top: 2rem;
  border-top: 1px solid #e2e8f0;
}

.violations-footer p {
  color: #64748b;
  font-size: 0.9375rem;
  margin-bottom: 1rem;
}

.violations-footer p i {
  color: #f59e0b;
  margin-right: 0.5rem;
}

.report-link {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  background: #10b981;
  color: #ffffff;
  font-weight: 600;
  font-size: 0.9rem;
  text-decoration: none;
  padding: 0.6rem 1.1rem;
  border-radius: 10px;
  margin-right: 0.8rem;
}

.report-link:hover {
  background: #059669;
  color: #ffffff;
}

.handbook-link {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  color: #10b981;
  font-weight: 600;
  font-size: 0.9375rem;
  text-decoration: none;
  transition: all 0.3s ease;
}

.handbook-link:hover {
  color: #059669;
  gap: 0.75rem;
}

@media (max-width: 768px) {
  .violations-section h2 {
    font-size: 1.75rem;
  }
}
</style>
